import { connect } from 'react-redux';
import View from './HomeownersAssociationFeeView';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import nullableHomeownersAssociationFeeSelector from './HomeownersAssociationFeeSelector';
import {
  alreadyHadAssociationFeeSelector,
  yesOrNoHomeownerAssociationFeeSelector,
} from '../HasHomeownerAssociationFee/HasHomeownerAssociationFeeSelector';

const mapStateToProps = (state, ownProps) => ({
  workflowId: ownProps.workflowId,
  branch: ownProps.branch,
  nullableHomeownersAssociationFee: nullableHomeownersAssociationFeeSelector(state, ownProps),
  alreadyHadHomeownerAssociationFee: alreadyHadAssociationFeeSelector(state, ownProps),
  hasHomeownersAssociationFee: yesOrNoHomeownerAssociationFeeSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onHomeownersAssociationFeeValueChanged: workflowId => ({ target: { value } }) => {
    let MonthlyHoa = null;
    if (value !== '') {
      MonthlyHoa = +value;
    }

    dispatch(updateData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          MonthlyHoa,
        },
      },
      workflowId,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
